import { BodyText, Heading, LinkText } from '@postscript/components';
import DisplayCard from '../Layout/DisplayCard';
import {
  StyledBlockHeading,
  StyledCardGrid,
} from '../Layout/SimpleStyledComponents';
import SystemBlock from '../Layout/SystemBlock';

const ComponentsSection = (): JSX.Element => {
  return (
    <SystemBlock id="contributing">
      <StyledBlockHeading>
        <Heading as="h2" size="small">
          Contributing
        </Heading>
        <BodyText size="large">
          We&apos;re building a minimal but unique Design System at Postscript
          that encourages collaboration. Here, you&apos;ll find guidelines for
          designers and developers on contributing components, patterns,
          designs, or code.
        </BodyText>
      </StyledBlockHeading>

      <StyledCardGrid desktopColumns={2}>
        <DisplayCard
          heading="Design and code parity"
          description="A Design System is not just Figma and it's not just Storybook! 
          Keep code and design aligned as much as possible to ensure
          design and development are speaking the same language and telling the same story."
          emoji="clinking-beer-mugs"
          size="medium"
        />

        <DisplayCard
          heading="Storybook as the source of truth"
          description="We use Storybook as our source of truth. It contains all our component documentation and we strive to keep it in line with designs. If work exists in Figma but not in code, customers can't see it!"
          emoji="open-book"
          size="medium"
        />

        <DisplayCard
          heading="Expect things to change"
          description="The important thing is to think modularly, ensure we're using consistent components and patterns, and build in levers and dials that can be used to make big impact with small, iterative changes."
          emoji="coin"
          size="medium"
        />

        <DisplayCard
          heading="Give feedback and ask questions"
          advancedDescription={
            <BodyText>
              Wondering why things are the way that they are? The System is
              managed by the Design team. Feel free to ask us any questions you
              might have or provide us with your awesome feedback. You can learn
              more about contributing to the System as a designer or developer
              by reading{' '}
              <LinkText
                href="https://www.notion.so/postscriptio/Using-and-Contributing-to-the-Component-Library-ecb43bb69bf8403d9463129ad0c95193"
                target="_blank"
                rel="noreferrer"
              >
                this document
              </LinkText>
              .
            </BodyText>
          }
          emoji="thinking-face"
          size="medium"
        />
      </StyledCardGrid>
    </SystemBlock>
  );
};

export default ComponentsSection;
